<template>
  <div class="contentBox" v-loading="loading" :element-loading-text="loadTxt">
    <navBox :id="navId" :cid="childrenID" :tid="threeID" :fid="fourId" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content" >
      <myHeader ref="myHeader"></myHeader>
      <!-- 观看视频 -->
      <div class="msgBox videoMsg" v-if="videoType">
        <div class="contv">
            <button class="btn btn-video" @click="videoHide"></button>
            <video :src="'https://pic.bi-rong.com/'+videoUrl" controls></video>
        </div>
      </div>

      <!-- 预览 -->
      <div class="MobelBox videoCont" v-if="previewType">
        <p class="add-title">{{previewData.title}}</p>
        <button class="btn btn-hide"  @click="closeSub">关闭</button>

        <div class="videoList">
          <div class="video-item" v-for="(item,index) in previewData.video" :key="index" @click="lookVideo(item)">
            <p>第{{(index+1)}}小结：{{item.title}}</p>
            <video :src="'https://pic.bi-rong.com/'+item.video"></video>
          </div>
        </div>

        <div class="write-btnBox">
          <!-- <button class="btn btn-save" @click="saveSub">确定</button> -->
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>

      <div class="MobelBox" v-if="addType">
        <p class="add-title">添加母题</p>
        <button class="btn btn-hide"  @click="closeSub">关闭</button>
        <div class="navBtn">
          <div class="nav-item btn-base" :class="mobelType=='base'?'select':''" @click="navSub('base')">基础设置</div>
          <div class="nav-item btn-video" :class="mobelType=='video'?'select':''" @click="navSub('video')">视频设置</div>
        </div>

        <div class="baseBox" v-if="mobelType=='base'">
          <div class="write-txt">
            <p class="write-title"><span>*</span>母题名称：</p>
            <div class="write-text">
              <input type="text" placeholder="请输入视频名称" v-model="addObj.title">
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title"><span>*</span>状态：</p>
            <el-radio-group v-model="addObj.status">
              <el-radio :label="1">上架</el-radio>
              <el-radio :label="0">下架</el-radio>
            </el-radio-group>
          </div>

          <div class="write-txt">
            <p class="write-title"><span>*</span>文章内容：</p>
            <div class="write-text">
              <button class="btn btn-exam" @click="chooseTopic">从习题库中选择</button>
              <textarea placeholder="请输入文章内容" v-model="addObj.content"></textarea>
            </div>
          </div>

          

          <div class="write-txt write-ai">
            <p class="write-title"><span>*</span>文章一级标签：{{addObj.material_label_one}}</p>
            <button class="btn btn-ai" @click="aiSub('article',1)">{{addObj.material_label_one?'重新识别':'点击进行AI识别'}}</button>
            <span class="ai-msg">AI识别后可手动修改</span>
            <div class="write-text">
              <el-select placeholder="请选择" v-model="value1" @change="topicLabel('1',$event)">
                <el-option
                  v-for="item in articleOneList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="write-txt write-ai">
            <p class="write-title">文章二级标签：{{addObj.material_label_two}}</p>
            <button class="btn btn-ai" @click="aiSub('article',2)">{{addObj.material_label_two?'重新识别':'点击进行AI识别'}}</button>
            <span class="ai-msg">AI识别后可手动修改</span>
            <div class="write-text">
              <el-select  placeholder="请选择" v-model="value2" @change="topicLabel('2',$event)">
                <el-option
                  v-for="item in articleTwoList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="write-txt write-ai">
            <p class="write-title">文章三级标签：{{addObj.material_label_three}}</p>
            <button class="btn btn-ai" @click="aiSub('article',3)">{{addObj.material_label_three?'重新识别':'点击进行AI识别'}}</button>
            <span class="ai-msg">AI识别后可手动修改</span>
            <div class="write-text">
              <el-select  placeholder="请选择" v-model="value3" @change="topicLabel('3',$event)">
                <el-option
                  v-for="item in articleThreeList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>

          <div v-for="(item,index) in addObj.topic" :key="index" style="display: block;">
            <div class="write-txt">
              <p class="write-title"><span>*</span>原题题干：</p>
              <div class="write-text">
                <textarea placeholder="请输入原题题干" v-model="item.topic"></textarea>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title"><span>*</span>原题答案：</p>
              <div class="write-text">
                <textarea placeholder="请输入原题答案" v-model="item.answer"></textarea>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title"><span>*</span>综合解题步骤：</p>
              <div class="write-text">
                <textarea placeholder="请输入综合解题步骤" v-model="addObj.explain"></textarea>
              </div>
            </div>
          </div>
          

          <div class="sloveContent" v-for="(item,index) in addObj.topic" :key="index+1">
            <p class="slove-title">反向解题流程</p>
            <div class="title-list">
              <p class="title-list-item" v-for="(ele,num) in sloveTitle" :class="sloveID==(num+1)?'select':''" :key="ele.id" @click="sloveChange(num)">{{(num+1)}}. {{ele.title}}</p>
            </div>
            <div class="slove-item" v-if="sloveID == 1">
              <div class="topicList">
                <div class="topic-item">
                  <div class="topic-title">
                    考点定位练习
                    <!-- <button class="btn btn-remove" v-if="num>0" @click="removeTopic(ele,num,1)">删除</button> -->
                  </div>
                  <div class="write-txt write-ai">
                    <p class="write-title"><span>*</span>题干一级标签：{{item.location.topic_label_one}}</p>
                    <button class="btn btn-ai" @click="aiSub('topic',1,item.location)">{{item.location.topic_label_one?'重新识别':'点击进行AI识别'}}</button>
                    <span class="ai-msg">AI识别后可手动修改</span>
                    <div class="write-text">
                      <el-select  placeholder="请选择" v-model="topicValue1" @change="articleLabel('1',$event,'topic')">
                        <el-option
                          v-for="item in topicOneList"
                          :key="item.id"
                          :label="item.title"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="write-txt write-ai">
                    <p class="write-title">题干二级标签：{{item.location.topic_label_two}}</p>
                    <button class="btn btn-ai" @click="aiSub('topic',2,item.location)">{{item.location.topic_label_two?'重新识别':'点击进行AI识别'}}</button>
                    <span class="ai-msg">AI识别后可手动修改</span>
                    <div class="write-text">
                      <el-select  placeholder="请选择" v-model="topicValue2" @change="articleLabel('2',$event,'topic')">
                        <el-option
                          v-for="item in topicTwoList"
                          :key="item.id"
                          :label="item.title"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="write-txt write-ai">
                    <p class="write-title">题干三级标签：{{item.location.topic_label_three}}</p>
                    <button class="btn btn-ai" @click="aiSub('topic',3,item.location)">{{item.location.topic_label_three?'重新识别':'点击进行AI识别'}}</button>
                    <span class="ai-msg">AI识别后可手动修改</span>
                    <div class="write-text">
                      <el-select  placeholder="请选择" v-model="topicValue3" @change="articleLabel('3',$event,'topic')">
                        <el-option
                          v-for="item in topicThreeList"
                          :key="item.id"
                          :label="item.title"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="write-txt write-ai">
                    <p class="write-title">题型：</p>
                    <div class="write-text">
                      <input type="text" v-model="item.location.topic_type">
                    </div>
                    <button class="btn btn-ai" @click="aiSub('topicType',0,item.location)">{{item.location.topic_type?'重新识别':'点击进行AI识别'}}</button>
                    <span class="ai-msg">AI识别后可手动修改</span>
                  </div>

                  <div class="write-txt">
                    <p class="write-title"><span>*</span>问题：</p>
                    <div class="write-text">
                      <textarea placeholder="清输入问题" v-model="item.location.topic"></textarea>
                    </div>
                  </div>

                  <div class="write-txt">
                    <p class="write-title"><span>*</span>答案：</p>
                    <div class="write-text">
                      <textarea placeholder="请输入答案" v-model="item.location.answer"></textarea>
                    </div>
                  </div>

                  <div class="write-txt">
                    <p class="write-title"><span>*</span>考点定位解析：</p>
                    <div class="write-text">
                      <textarea placeholder="请输入考点定位解析" v-model="item.location.analysis"></textarea>
                    </div>
                  </div>
                </div>
                <!-- <button class="btn btn-topic-add" @click="addTopic(1)">+添加题目</button> -->
              </div>
            </div>

            <div class="slove-item" v-if="sloveID == 2">
              <div class="topicList">
                <div class="topic-item">
                  <div class="topic-title">
                    标答拆解练习
                    <!-- <button class="btn btn-remove" v-if="num>0"  @click="removeTopic(ele,num,2)">删除</button> -->
                  </div>
                  <div class="write-txt">
                    <p class="write-title"><span>*</span>问题：</p>
                    <div class="write-text">
                      <textarea placeholder="清输入问题" v-model="item.disassemble.topic"></textarea>
                    </div>
                  </div>

                  <div class="write-txt">
                    <p class="write-title"><span>*</span>答案：</p>
                    <div class="write-text">
                      <textarea placeholder="请输入答案" v-model="item.disassemble.answer"></textarea>
                    </div>
                  </div>

                  <div class="write-txt">
                    <p class="write-title"><span>*</span>标答拆解解析：</p>
                    <div class="write-text">
                      <textarea placeholder="请输入标答拆解解析" v-model="item.disassemble.analysis"></textarea>
                    </div>
                  </div>
                </div>
                <!-- <button class="btn btn-topic-add" @click="addTopic(2)">+添加题目</button> -->
              </div>
            </div>

            <div class="slove-item" v-if="sloveID == 3">
              <div class="topicList">
                <div class="topic-item">
                  <div class="topic-title">
                    步骤逆推练习
                    <!-- <button class="btn btn-remove" v-if="num>0" @click="removeTopic(ele,num,3)">删除</button> -->
                  </div>
                  <div class="write-txt">
                    <p class="write-title"><span>*</span>问题：</p>
                    <div class="write-text">
                      <textarea placeholder="清输入问题" v-model="item.backstepping.topic"></textarea>
                    </div>
                  </div>

                  <div class="write-txt">
                    <p class="write-title"><span>*</span>识别答案：</p>
                    <div class="write-text">
                      <textarea placeholder="请输入识别答案" v-model="item.backstepping.identify_answer"></textarea>
                    </div>
                  </div>

                  <div class="write-txt">
                    <p class="write-title"><span>*</span>提取答案：</p>
                    <div class="write-text">
                      <textarea placeholder="请输入提取答案" v-model="item.backstepping.extract_answer"></textarea>
                    </div>
                  </div>

                  <div class="write-txt">
                    <p class="write-title"><span>*</span>组装答案：</p>
                    <div class="write-text">
                      <textarea placeholder="请输入组装答案" v-model="item.backstepping.assembly_answer"></textarea>
                    </div>
                  </div>

                  <div class="write-txt">
                    <p class="write-title"><span>*</span>答案：</p>
                    <div class="write-text">
                      <textarea placeholder="请输入答案" v-model="item.backstepping.answer"></textarea>
                    </div>
                  </div>

                  <div class="write-txt">
                    <p class="write-title"><span>*</span>步骤逆推解析：</p>
                    <div class="write-text">
                      <textarea placeholder="请输入步骤逆推解析" v-model="item.backstepping.analysis"></textarea>
                    </div>
                  </div>
                </div>
                <!-- <button class="btn btn-topic-add" @click="addTopic(3)">+添加题目</button> -->
              </div>
            </div>
          </div>

          
        </div>


        <div class="videoBox" v-if="mobelType=='video'">
          <div class="topicList">
            <div class="topic-item" v-for="(item,index) in addObj.video" :key="index">
              <div class="topic-title">
                第{{(index+1)}}小节
                <button class="btn btn-remove" @click="removeVideo(item,index)">删除</button>
              </div>
              <div class="write-txt">
                <p class="write-title"><span>*</span>小节名称：</p>
                <div class="write-text">
                  <input type="text" placeholder="请输入小节名称" v-model="item.title">
                </div>
              </div>

              <div class="write-txt write-ai">
                <p class="write-title"><span>*</span>上传课件:</p>
                <div class="write-text">
                  <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="item.video">
                    <video :src="'https://pic.bi-rong.com/'+item.video" alt=""></video>
                    <div class="hover" v-if="imgType">
                      <i class="icon-delete" @click="imgRemove"></i>
                    </div>
                  </div>
                  <el-upload
                    :action="'https://upload.qiniup.com'"
                    :data="uploadObj"
                    list-type="picture-card"
                    :before-upload="(file)=>{return beforeUploadVideo(file,item)}"
                    :on-success="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,item,'video')}"
                    :on-progress="handleProgressImg"
                    :on-remove="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,item,'video')}"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img
                      width="100%"
                      :src="'https://pic.bi-rong.com/' + item.video"
                      alt=""
                    />
                  </el-dialog>
                </div>
              </div>
            </div>
            <button class="btn btn-topic-add" @click="addTopic">+添加小节</button>
          </div>
        </div>
        

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>

       <!-- 学生选择列表 -->
      <div class="organiza-txt studentList" v-if="listType">
        <div class="organiza-list">
          <div class="list-title">选择练习题</div>
          <div class="searchBox clear">
            <div class="search-item">
              <p>文章/题干：</p>
              <input type="text" placeholder="请输入要搜索的文章/题干" v-model="listObj.title">
            </div>
            <div style="display: block;margin: 20px 0;">
              <div class="search-item">
                <p>文章一级标签：</p>
                <el-select placeholder="请选择" v-model="listObj.material_label_one" @change="articleLabel('1',$event)">
                  <el-option
                    v-for="item in articleOneList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.title">
                  </el-option>
                </el-select>
              </div>
              <div class="search-item">
                <p>文章二级标签：</p>
                <el-select placeholder="请选择" v-model="listObj.material_label_two" @change="articleLabel('2',$event)">
                  <el-option
                    v-for="item in articleTwoList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.title">
                  </el-option>
                </el-select>
              </div>
              <div class="search-item">
                <p>文章三级标签：</p>
                <el-select placeholder="请选择" v-model="listObj.material_label_three" @change="articleLabel('3',$event)">
                  <el-option
                    v-for="item in articleThreeList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.title">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div style="display: block;">
              <div class="search-item">
                <p>题干一级标签：</p>
                <el-select  placeholder="请选择" v-model="listObj.topic_label_one" @change="articleLabel('1',$event,'topic')">
                  <el-option
                    v-for="item in topicOneList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.title">
                  </el-option>
                </el-select>
              </div>
              <div class="search-item">
                <p>题干二级标签：</p>
                <el-select  placeholder="请选择" v-model="listObj.topic_label_two" @change="articleLabel('2',$event,'topic')">
                  <el-option
                    v-for="item in topicTwoList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.title">
                  </el-option>
                </el-select>
              </div>
              <div class="search-item">
                <p>题干三级标签：</p>
                <el-select  placeholder="请选择" v-model="listObj.topic_label_three" @change="articleLabel('3',$event,'topic')">
                  <el-option
                    v-for="item in topicThreeList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.title">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="topicSearch">搜索</button>
              <button class="btn btn-reset" @click="topicReset">重置</button>
            </div>
          </div>
          <div class="titleList">
            <p v-for="item in studentTitle" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in studentList" v-bind:key="(index+1)" @click="topicChoose(item,index)">
              <p :title="item.key" class="radio" :class="topicID===index?'select':''">
                <span></span>
              </p>
              <p :title="item.content">{{item.content}}</p>
              <p :title="item.material_label_one">{{item.material_label_one}}</p>
              <p :title="item.material_label_two">{{item.material_label_two}}</p>
              <p :title="item.material_label_three">{{item.material_label_three}}</p>
              <p :title="item.topic">{{item.topic}}</p>
              <p :title="item.topic_label_one">{{item.topic_label_one}}</p>
              <p :title="item.topic_label_two">{{item.topic_label_two}}</p>
              <p :title="item.topic_label_three">{{item.topic_label_three}}</p>
              <p :title="item.answer">{{item.answer}}</p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="listChange"
              :current-page.sync="listObj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="listTotalPage">
            </el-pagination> 
          </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="studentSub">确定</button>
          <button class="btn btn-close" @click="studentHide">取消</button>
        </div>
      </div>  

      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加母题</p>
          </div>
          <div class="searchBox clear">
            <div class="search-item">
              <p>文章/题干:</p>
              <input type="text" placeholder="请输入要搜索的文章/题干" v-model="obj.title">
            </div>
            <div class="search-item">
              <p>文章一级标签:</p>
              <el-select v-model="obj.material_label_one" filterable placeholder="请选择">
                <el-option
                  v-for="item in labelList1"
                  :key="item.id"
                  :label="item.title"
                  :value="item.title">
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <p>题干一级标签:</p>
              <el-select v-model="obj.topic_label_one" filterable placeholder="请选择">
                <el-option
                  v-for="item in labelList2"
                  :key="item.id"
                  :label="item.title"
                  :value="item.title">
                </el-option>
              </el-select>
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="list-title">母题列表<p>列表中多次出现同一个文章时，则代表该文章存在多个题干</p></div>
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.content">{{item.content}}</p>
              <p :title="item.material_label_one">{{item.material_label_one}}</p>
              <p :title="item.topic">{{item.topic}}</p>
              <p :title="item.topic_label_one">{{item.topic_label_one}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.status==0?'下架':'上架'">{{item.status==0?'下架':'上架'}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p>
                <button title="编辑" class="btn btn-revise" @click="buildShow(item)">编辑</button>
                <button title="上下架" class="btn btn-remove btn-red" @click="switchChange(item)">{{item.status==0?'上架':'下架'}}</button>
                <button title="编辑" class="btn btn-revise" @click="PreviewShow(item)">预览母题</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { solveGetVideoPackageList ,solveUpdateVideoPackageStatus ,solveSaveVideoPackage ,solveGetVideoPackageDetail,getAiRecognition,getTypeLabelList,solveGetTopicDetail,solveGetTopicSelectList } from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import axios from "axios"
export default {
  name: "index",
  data() {
    return {
      navId:'1',
      childrenID:'1-1',
      threeID:'1-1-1',
      fourId:'1-1-2-2',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'文章'},
        {id:3,title:'文章一级标签'},
        {id:4,title:'题干'},
        {id:5,title:'题干一级标签'},
        {id:6,title:'母题名称'},
        {id:7,title:'上/下架'},
        {id:8,title:'创建时间'},
        {id:9,title:'操作'},
      ],
      dataList:[],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10,
        status:9
      },
      addObj:{
        title:'',
        status:1,
        content:'',
        explain:'',
        material_label_one:'',
        material_label_two:'',
        material_label_three:'',
        topic:[
          {
            topic:'',
            answer:'',
            location:{topic:'',topic_type:'',answer:'',topic_label_one:'',topic_label_two:'',topic_label_three:'',analysis:''},
            disassemble:{topic:'',answer:'',analysis:''},
            backstepping:{topic:'',identify_answer:'',extract_answer:'',assembly_answer:'',answer:'',analysis:''}
          }
        ],
        video:[
          {title:'',video:'',total_time:'',content:''}
        ]
      },
      totalPage:0,
      removeID:'',
      url:'',
      statusList:[
        {id:9,title:'全部',value:9},
        {id:0,title:'下架',value:0},
        {id:1,title:'上架',value:1},
      ],
      loading:false,
      loadTxt:'',
      uploadObj: {
        token: "",
        key: "",
      },
      dialogVisible:false,
      imgType:false,
      mobelType:'base',
      value1:'',
      value2:'',
      value3:'',
      articleOneList:[],
      articleTwoList:[],
      articleThreeList:[],
      topicOneList:[],
      topicTwoList:[],
      topicThreeList:[],
      topicValue1:'',
      topicValue2:'',
      topicValue3:'',
      labelList1:[],
      labelList2:[],
      listType:false,
      listObj:{
        page:1,
        rows:10
      },
      topicID:'',
      weekIndex:'',
      topicIndex:'',
      studentList:[],
      studentTitle:[
        {id:1,title:''},
        {id:2,title:'文章'},
        {id:3,title:'文章一级'},
        {id:4,title:'文章二级'},
        {id:5,title:'文章三级'},
        {id:6,title:'题干'},
        {id:7,title:'题干一级'},
        {id:8,title:'题干二级'},
        {id:9,title:'题干三级'},
        {id:10,title:'答案'},
      ],
      previewType:false,
      previewData:'',
      videoType:false,
      videoUrl:'',
      sloveTitle:[
        {id:1,title:'考点定位'},
        {id:2,title:'标答拆解'},
        {id:3,title:'步骤逆推'},
      ],
      sloveID:1
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.token = userData.adminToken;
    this.url = this.$refs.navBox.url;
    this.getList();
    this.getToken();
    
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },
    listChange(val) {
      console.log(`当前页: ${val}`);
      this.chooseTopic();
    },

    getToken(){
      var that = this;
      var url = this.$refs.navBox.url;
      axios({
        url:url+'/api/upload/getUploadToken',
        method:'post', 
      }).then((arr) => {
        if(arr.data.code == 200){
          that.uploadObj.token = arr.data.data.token
        } else {
          that.$message(arr.data.msg);
        }
        console.log(that.uploadObj);
      })
      .catch((error) => {
        console.log(error);
      });
    },

    async getList(){
      var that = this;
      try {
        const response = await solveGetVideoPackageList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.status==0){
              item.status=false
            } else {
              item.status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }

      try {
        const response = await getTypeLabelList({type:1,table_type:1},this.token);
        if(response.code == 200){
          that.labelList1 = response.data;
          that.articleOneList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }

      try {
        const response = await getTypeLabelList({type:1,table_type:2},this.token);
        if(response.code == 200){
          that.labelList2 = response.data;
          that.topicOneList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async switchChange(e){
      var that = this;
      var obj = {
        id:e.vpid,
        status:e.status?0:1,
      };
      try {
        const response = await solveUpdateVideoPackageStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
          that.getList();      
        } else {
          that.$message(response.msg);
          e.status = !e.status;
        }
      } catch (error) {
        that.$message(error);
        e.status = !e.status;
      }
    },

    async addSub(){
      var that = this;
      this.addType = 'add';
    },

    async buildShow(e){
      var that = this;
      try {
        const response = await solveGetVideoPackageDetail({id:e.vpid},this.token);
        if(response.code == 200){
          that.addType = 'edit';
          that.addObj = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    async saveSub(){
      var that = this;
      if(this.addObj.title == ''){
        that.$message('请填写视频名称！');
        return false;
      }
      if(this.addObj.content == ''){
        that.$message('请填写文章内容！');
        return false;
      }
      if(this.addObj.material_label_one == ''){
        that.$message('请选择或识别文章一级标签！');
        return false;
      }
      // try {
      //     that.addObj.topic.forEach(function(item,index){
      //       if(item.topic == ''){
      //           that.$message('题目'+(index+1)+'题干未填写');
      //           throw new Error("EndIterative");
      //       } 
      //       if(item.topic_label_one == ''){
      //           that.$message('题目'+(index+1)+'题干一级标签未填写');
      //           throw new Error("EndIterative");
      //       } 
      //       if(item.answer == ''){
      //           that.$message('题目'+(index+1)+'答案未填写');
      //           throw new Error("EndIterative");
      //       } 
      //     })

      //     that.addObj.video.forEach(function(item,index){
      //       if(item.title == ''){
      //           that.$message('第'+(index+1)+'小节名称未填写');
      //           throw new Error("EndIterative");
      //       } 
      //       if(item.video == ''){
      //         that.$message('第'+(index+1)+'小节视频未添加');
      //           throw new Error("EndIterative");
      //       } 
      //     })

          
      // } catch(e) {
      //     if (e.message != "EndIterative") {
      //         throw e;
      //     } else {
      //         return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
      //     }
      // };
      console.log(this.addObj);
      // return false;
      try {
        const response = await solveSaveVideoPackage(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.previewType = '';
      this.previewData = '';
      this.addObj = {
        title:'',
        status:1,
        content:'',
        explain:'',
        material_label_one:'',
        material_label_two:'',
        material_label_three:'',
        topic:[
          {
            topic:'',
            answer:'',
            location:{topic:'',topic_type:'',answer:'',topic_label_one:'',topic_label_two:'',topic_label_three:'',analysis:''},
            disassemble:{topic:'',answer:'',analysis:''},
            backstepping:{topic:'',identify_answer:'',extract_answer:'',assembly_answer:'',answer:'',analysis:''}
          }
        ],
        video:[
          {title:'',video:'',total_time:'',content:''}
        ]
      }
    },

    PreviewShow(e){
      this.previewType = true;
      this.previewData = e;
      console.log(this.previewData)
    },

    lookVideo(e){
      this.videoType = true;
      this.videoUrl = e.video;
    },

    videoHide(){
      this.videoType = false;
      this.videoUrl = '';
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj={
        page:1,
        rows:10,
      };
      this.addObj = {
        title:'',
        status:1,
        content:'',
        explain:'',
        material_label_one:'',
        material_label_two:'',
        material_label_three:'',
        topic:[
          {
            topic:'',
            answer:'',
            location:{topic:'',topic_type:'',answer:'',topic_label_one:'',topic_label_two:'',topic_label_three:'',analysis:''},
            disassemble:{topic:'',answer:'',analysis:''},
            backstepping:{topic:'',identify_answer:'',extract_answer:'',assembly_answer:'',answer:'',analysis:''}
          }
        ],
        video:[
          {title:'',video:'',total_time:'',content:''}
        ]
      }
      this.totalPage = 0;
      this.dataList = [];
      this.getList();
    },

    addTopic(){
      var list = {title:'',video:'',total_time:'',content:''}
      this.addObj.video.push(list);
      this.$forceUpdate();
    },

    addTopicList(){
      var list = {
        topic:'',
        topic_type:'',
        answer:'',
        topic_label_one:'',
        topic_label_two:'',
        topic_label_three:'',
      }
      this.addObj.topic.push(list);
      this.topicValue1 = '';
      this.topicValue2 = '';
      this.topicValue3 = '';
    },

    removeTopic(e,i){
      this.addObj.topic.splice(i,1)
    },

    removeVideo(e,i){
      this.addObj.video.splice(i,1)
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      this.addObj.image = '';
    },

    beforeUploadVideo(file,item) {
      console.log(file,item,'====filefilefile==')
      var url = URL.createObjectURL(file);
      var audioElement = new Audio(url);
      audioElement.addEventListener("loadedmetadata",
          function () {
            console.log(parseInt(audioElement.duration))
            item.total_time = parseInt(audioElement.duration)
      });

      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    handleSuccessVideo(response, file, fileList,e,type,num) {
      e.video = response.key;
      console.log(e,'==file==')
      this.loading = false;
      this.uploadObj.key = "";
    },

    handleRemoveVideo(response, file, fileList,index,type,num) {
      if(type == 'video'){
        this.examObj.level[index].image_videos[num].static_video = '';
      } else {
        this.examObj.level[index].image_videos[num].video = '';
      }
    },

    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    navSub(type){
      this.mobelType = type
    },


    async aiSub(type,i,e){
      var that = this;
      var obj = {};
      if(this.addObj.content == ''){
        that.$message('请填写文章内容！');
        return false;
      }
      if(type=='article'){
        obj = {
          type:1,
          level:i,
          content:this.addObj.content,
        };
        if(i == 2){
          that.addObj.material_label_two = '生成中...'
          obj.material_label_one = that.addObj.material_label_one ? that.addObj.material_label_one : this.value1
        }
        if(i == 3){
          that.addObj.material_label_three = '生成中...'
          obj.material_label_two = that.addObj.material_label_two ? that.addObj.material_label_two : this.value2
        }
        if(i == 1){
          that.addObj.material_label_one = '生成中...'
          that.getTypeList(i,'article')
        }

      } else if(type == 'topic'){
        try {
          that.addObj.topic.forEach(function(item,index){
            if(item.topic == ''){
                that.$message('题目'+(index+1)+'题干还未填写');
                throw new Error("EndIterative");
            } else {
                // console.log(ele,num);
            }
          })
      } catch(e) {
          if (e.message != "EndIterative") {
              throw e;
          } else {
              return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
          }
      };
        obj = {
          type:2,
          level:i,
          content:this.addObj.content,
          topic:e.topic
        };
        if(i == 2){
          e.topic_label_two = '生成中...'
          obj.topic_label_one = e.topic_label_one ? e.topic_label_one : this.topicValue1;
        }
        if(i == 3){
          e.topic_label_three = '生成中...'
          obj.topic_label_two = e.topic_label_two ? e.topic_label_two : this.topicValue2;
        }
        if(i == 1){
          e.topic_label_one = '生成中...'
          that.getTypeList(i,'topic')
        }
      } else if(type == 'topicType'){
        obj = {
          type:3,
          topic:e.topic,
        }
        e.topic_type = '生成中...'
      };
      this.loading = true;
      this.loadTxt = '请稍后...'
      try {
        const response = await getAiRecognition(obj,this.token);
        if(response.code == 200){
          if(type == 'article'){
            if(i == 1){
              that.addObj.material_label_one = response.data.answer;
              that.value1 = '';
            } else if(i == 2){
              that.addObj.material_label_two = response.data.answer;
              that.value2 = '';
            } else if(i == 3){
              that.addObj.material_label_three = response.data.answer;
              that.value3 = '';
            } 
          } else if(type == 'topic'){
            if(i == 1){
              e.topic_label_one = response.data.answer;
              that.topicValue1 = '';
            } else if(i == 2){
              e.topic_label_two = response.data.answer;
              that.topicValue2 = '';
            } else if(i == 3){
              e.topic_label_three = response.data.answer;
              that.topicValue3 = '';
            } 
          } else if(type == 'topicType'){
            e.topic_type = response.data.answer;
          };
          that.$forceUpdate();
        } else {
          that.$message(response.msg);
        };
        that.loading = false;
      } catch (error) {
        that.loading = false;
        that.$message(error);
      }
    },

    topicLabel(type,e,topic,num){
      var that = this;
      if(type == 1){
        if(topic == 'topic'){
          that.getTopicTypeList(2,'topic');
          that.topicOneList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.topic[num].topic_label_one = item.title
            }
          });
          that.addObj.topic[num].topic_label_two = '';
          that.topicValue2 = '';
          that.addObj.topic[num].topic_label_three = '';
          that.topicValue3 = '';
        } else {
          that.getTopicTypeList(2,'article');
          that.addObj.material_label_two = '';
          that.value2 = '';
          that.addObj.material_label_three = '';
          that.value3 = '';
          that.articleOneList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.material_label_one = item.title
            }
          });
          
        }
      } else if(type == 2){
        if(topic == 'topic'){
          that.getTopicTypeList(3,'topic')
          that.topicTwoList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.topic[num].topic_label_two = item.title
            }
          });
          that.addObj.topic[num].topic_label_three = '';
          that.topicValue3 = '';
        } else {
          that.getTopicTypeList(3,'article')
          that.articleTwoList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.material_label_two = item.title
            }
          });
          that.addObj.material_label_three = '';
          that.value3 = '';
        }
      } else if(type == 3){
        if(topic == 'topic'){
          that.topicThreeList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.topic[num].topic_label_three = item.title
            }
          });
        } else {
          that.articleThreeList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.material_label_three = item.title
            }
          });
        }
      }
    },

    articleLabel(type,e,topic,num){
      var that = this;
      var value = ''
      if(type == 1){
        if(topic == 'topic'){
          that.listObj.topic_label_two = '';
          that.listObj.topic_label_three = '';
          that.topicOneList.forEach(function(item,index){
            if(item.title == that.listObj.topic_label_one){
              value = item.id;
            }
          })
          console.log(value,'==that.listObj.topic_label_one==')
          that.getTypeList(2,'topic',value);
        } else {
          that.listObj.material_label_two = '';
          that.listObj.material_label_three = '';
          that.articleOneList.forEach(function(item,index){
            if(item.title == that.listObj.material_label_one){
              value = item.id;
            }
          })
          that.getTypeList(2,'article',value);
        }
      } else if(type == 2){
        if(topic == 'topic'){
          that.topicTwoList.forEach(function(item,index){
            if(item.title == that.listObj.topic_label_two){
              value = item.id;
            }
          })
          that.getTypeList(3,'topic',value)
          that.listObj.topic_label_three = '';
        } else {
          that.articleTwoList.forEach(function(item,index){
            if(item.title == that.listObj.material_label_two){
              value = item.id;
            }
          })
          that.getTypeList(3,'article',value)
          that.listObj.material_label_three = '';
        }
      } else if(type == 3){
        if(topic == 'topic'){
          
        } else {
        }
        that.$forceUpdate()
      }
    },

    async getTopicTypeList(i,type){
      var that = this;
      var obj = {};
      if(i == 1){
        obj = {
          type:i,
          table_type:1
        }
        if(type == 'topic'){
          obj.table_type = 2
        }
      }
      if(i == 2){
        obj = {
          type : 2,
          one_id:that.value1,
          table_type:1
        };
        if(type == 'topic'){
          obj.one_id = this.topicValue1;
          obj.table_type = 2
        };
      }
      if(i == 3){
        obj = {
          type : 3,
          two_id:this.value2,
          table_type:1
        }
        if(type == 'topic'){
          obj.two_id = that.topicValue2;
          obj.table_type = 2
        }
      }
      try {
        const response = await getTypeLabelList(obj,this.token);
        if(response.code == 200){
          if(i == 1){
            if(type == 'article'){
              that.articleOneList = response.data;
            } else {
              that.topicOneList = response.data;
            }
          }
          if(i == 2){
            if(type == 'article'){
              that.articleTwoList = response.data;
            } else {
              that.topicTwoList = response.data;
            }
          }
          if(i == 3){
            if(type == 'article'){
              that.articleThreeList = response.data;
            } else {
              that.topicThreeList = response.data;
            }
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async getTypeList(i,type,e){
      console.log(i,type,e,'==eeeee==')
      var that = this;
      var obj = {};
      if(i == 1){
        obj = {
          type:i,
          table_type:1
        }
        if(type == 'topic'){
          obj.table_type = 2
        }
      }
      if(i == 2){
        obj = {
          type : 2,
          one_id:e,
          table_type:1
        };
        if(type == 'topic'){
          obj.table_type = 2
        };
      }
      if(i == 3){
        obj = {
          type : 3,
          two_id:e,
          table_type:1
        }
        if(type == 'topic'){
          obj.table_type = 2
        }
      }
      try {
        const response = await getTypeLabelList(obj,this.token);
        if(response.code == 200){
          if(i == 1){
            if(type == 'article'){
              that.articleOneList = response.data;
            } else {
              that.topicOneList = response.data;
            }
          }
          if(i == 2){
            if(type == 'article'){
              that.articleTwoList = response.data;
            } else {
              that.topicTwoList = response.data;
            }
          }
          if(i == 3){
            if(type == 'article'){
              that.articleThreeList = response.data;
            } else {
              that.topicThreeList = response.data;
            }
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async topicChoose(e,i){
      var that = this; 
      var title = JSON.parse(JSON.stringify(this.addObj.title));
      var status = JSON.parse(JSON.stringify(this.addObj.status));
      try {
        const response = await solveGetTopicDetail({tmid:e.tmid},this.token);
        if(response.code == 200){
          that.topicID = i;
          that.addObj = response.data;;
          if(!response.data.video){
            that.addObj.video = [
              {title:'',video:'',total_time:'',content:''}
            ]
          }
          that.addObj.title = title;
          that.addObj.status = status;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    studentSub(){
      var that = this;
      this.listType = false;
      this.topicID='';
    },

    studentHide(){
      this.listType = false;
      this.studentList = [];
    },

    async chooseTopic(i,n){
      var that = this;   
      try {
        const response = await solveGetTopicSelectList(this.listObj,this.token);
        if(response.code == 200){
          that.listType = true;
          that.studentList = response.data.list;
          that.listTotalPage = response.data.total_page;
          that.getTypeList(1,'article')
          that.getTypeList(1,'topic')
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    topicSearch(){
      this.listObj.page = 1;
      this.chooseTopic();
    },

    topicReset(){
      this.listObj = {
        page:1,
        rows:10
      };
      this.studentList = [];
      this.chooseTopic();
    },

     sloveChange(i){
      this.sloveID = i+1;
      console.log(i,this.sloveID)
    },
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 9 );
    white-space: nowrap; /* 禁止文本换行 */
    overflow: hidden; /* 隐藏超出范围的内容 */
    text-overflow: ellipsis; /* 使用省略号 */
    padding: 21px 5px;
  }

  /* .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 10px;
  } */

  .add-title,
  .list-title{
    color: #333333;
    font-size: 22px;
    display: block;
    margin-bottom: 20px;
    position: relative;
    padding-left: 20px;
  }

  .add-title::before,
  .list-title::before{
    content: '';
    width: 5px;
    height: 22px;
    background-color: #6098F2;
    position: absolute;
    top: 50%;
    transform: translate(0,-50%);
    left: 5px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 334px;
    background-color: #FFFFFF;
    border-radius: 6px;
    display: block;
    padding: 20px;
    box-sizing: border-box;
    border: solid 1px #333333;
    font-size: 16px;
  }

  .MobelBox input{
    height: 50px;
    line-height: 50px;
    width: 500px;
  }

  .MobelBox>>> .el-input{
    font-size: 16px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.btn-ai{
  background-color: #6098F2;
  border-radius: 6px;
  color: #fff;
  font-size: 16px;
  color: #fff;
  box-sizing: border-box;
  padding: 0px 20px;
  height: 39px;
  line-height: 39px;
  display: inline-block;
  margin-left: 20px;
}

.ai-msg{
  height: 50px;
  line-height: 50px;
  color: #777777;
  font-size: 14px;
  display: inline-block;
  margin-left: 18px;
}

.MobelBox .write-ai .write-text{
  width: auto;
}

.MobelBox>>> .el-radio__inner{
  width: 20px;
  height: 20px;
}

.MobelBox>>> .el-radio{
  line-height: 50px;
}

.MobelBox>>> .el-radio__label{
  font-size: 18px;
}

.MobelBox>>> .el-radio__inner::after{
  width: 10px;
  height: 10px;
}


.topicList{
  display: block;
}

.topic-title{
  font-size: 20px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-bottom: 20px;
}

.topic-title .btn-add,
.topic-title .btn-remove{
  font-size: 18px;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  background-color: #6098F2;
  background-image: none;
  width: 110px;
  border-radius: 6px;
}

.topic-title .btn-remove{
  margin-left: 40px;
  background-color: transparent;
  color: #6098F2;
  border: solid 1px #6098F2;
}

.topic-title .btn-add{
  background-color: #F5F5F5;
  color: #999999;
  margin-left: 20px;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}

.btn-topic-add{
  font-size: 18px;
  color: #6098F2;
  margin: 30px 0 20px;
  display: block;  
  border: solid 1px #6098F2;
  border-radius: 6px;
  padding: 3px 30px;
  box-sizing: border-box;
}

.MobelBox{
  position: relative;
}

.navBtn{
  font-size: 0;
  position: absolute;
  top: 92px;
  left: 50%;
  transform: translate(-50%,0);
}

.navBtn .nav-item{
  display: inline-block;
  vertical-align: top;
  color: #333333;
  font-size: 24px;
  margin-right: 24px;
  padding-bottom: 4px;
}

.navBtn .nav-item.select{
  font-size: 26px;
  font-weight: bold;
  border-bottom: solid 4px #6098F2;
}

.videoBox,
.baseBox{
  display: block;
}

.btn-exam{
  display: block;
  margin-bottom: 10px;
  font-size: 18px;
  box-sizing: border-box;
  padding: 8px 15px;
  border-radius: 6px;
  background-color: #6098F2;
  color: #fff;
}

 .content{
  position: relative;
 } 

.studentList  {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 80px;
  left: 0;
  background-color: #fff;
  z-index: 10;
}

.studentList .organiza-list{
  height: 80%;
}

.studentList .dataList{
  height: calc( 100% - 400px );
}

.studentList .searchBox {
  padding: 0;
  margin-top: 25px;
  float: none;
}

.studentList .searchBox .search-item p{
  width: 100px;
  padding: 0;
}

.studentList .titleList{
  background-color: #F0F4FB;
  margin-top: 20px;
}

.studentList .dataList .listItem p,
.studentList .organiza-list p{
  width: calc( 100% / 10 );
  padding: 21px 5px;
  white-space: nowrap; /* 禁止文本换行 */
  overflow: hidden; /* 隐藏超出范围的内容 */
  text-overflow: ellipsis; /* 使用省略号 */
}

.studentList .dataList .listItem p.radio span{
  width: 20px;
  height: 20px;
  background-color: #D9D9D9;
  border-radius: 4px;
  display: block;
}

.studentList .dataList .listItem p.select span{
  background-color: #6098F2;
}

.studentList .dataList .listItem p.select span::before{
  content: '✔';
  width: 20px;
  height: 20px;
  display: block;
  color: #ffff;
  margin: 0 5px;
}

.studentList>>> .el-radio__inner{
  width: 20px;
  height: 20px;
  border-width:  2px;
}

.studentList>>> .el-radio__label{
  font-size: 18px;
  display: none;
}

.studentList>>> .el-radio__inner::after{
  width: 10px;
  height: 10px;
}

.videoCont .videoList{
  font-size: 0;
}

.videoCont .videoList .video-item{
  display: block;
  margin-bottom: 20px;
}

.videoCont .videoList .video-item p{
  font-size: 18px;
  color: #333333;
  display: block;
  margin-bottom: 15px;
}

.videoCont .videoList .video-item video{
  width: 200px;
  display: block;
  cursor: pointer;
}

.msgBox.videoMsg .btn-video{
  background-image: url(~@/assets/images/btn-close.png);
}

.sloveContent{
  display: block;
  margin-top: 70px;
}

.sloveContent .slove-title{
  font-size: 28px;
  color: #333333;
  display: block;
  text-align: center;
}

.sloveContent .title-list{
  font-size: 0;
  text-align: center;
  margin-top: 40px;
}

.sloveContent .title-list p{
  display: inline-block;
  vertical-align: top;
  font-size: 24px;
  color: #777777;
  padding-bottom: 16px;
}

.sloveContent .title-list p.select{
  border-bottom: solid 4px #6098F2;
  color: #333333;
}

.sloveContent .title-list p:nth-of-type(2){
  margin: 0 246px;
}


.msgBox.videoMsg .contv{
  max-height:80%;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 0;
}

.msgBox.videoMsg .btn-video{
  top: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/solve/video.vue